import angular from 'angular';
import template from './template.html';
import './style.scss';

export class LanguagesSection {
    /* @ngInject */
    constructor(staticDataService) {
        staticDataService.getStaticData('languages', data => this.lookupLanguages = data);
    }
}

export const LanguagesSectionConfiguration = {
    template,
    controller: LanguagesSection,
    bindings: {
        languages: '<',
        canEdit: '<',
        onLanguagesChange: '&'
    },
    controllerAs: 'languagesSectionCtrl'
};

angular.module('TALENYA-FE').component('candidateLanguagesSection', LanguagesSectionConfiguration);
